export default "__VITE_ASSET__BKsyXfw1__"